import * as React from 'react';
import { UitkSpacing } from 'uitk-react-spacing';
var CobrandHeaderLogo = function (_a) {
  var logoUrl = _a.logoUrl,
    logoAltText = _a.logoAltText,
    logoHref = _a.logoHref;
  var cobrand = "".concat(logoUrl, "&test=hawaiian_cobrand");
  if (!cobrand || !logoAltText) {
    return null;
  }
  return React.createElement(UitkSpacing, {
    padding: {
      block: 'two',
      inlineend: 'two'
    }
  }, React.createElement("a", {
    href: logoHref || '/',
    className: "header-logo"
  }, React.createElement("img", {
    src: cobrand,
    alt: logoAltText
  })));
};
export { CobrandHeaderLogo };